export default __webpack_public_path__ + "static/media/ImageSub.be6536b4.png";